"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.returnImageCorrect = void 0;
function returnImageCorrect(category) {
    if (category === 'pantalone') {
        return '/modules/custom/uniforms/js/src/assets/image/pant.png';
    }
    else if (category === 'casacca') {
        return '/modules/custom/uniforms/js/src/assets/image/cas.png';
    }
    else if (category === 'pile') {
        return '/modules/custom/uniforms/js/src/assets/image/pile.png';
    }
    else if (category === 'camicie') {
        return '/modules/custom/uniforms/js/src/assets/image/camicie.png';
    }
    else if (category === 'calzone') {
        return '/modules/custom/uniforms/js/src/assets/image/calzone.png';
    }
    else if (category === 'giacca') {
        return '/modules/custom/uniforms/js/src/assets/image/giacca.png';
    }
}
exports.returnImageCorrect = returnImageCorrect;
